import styled from "styled-components";

export const Container = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 6px;
    padding-bottom: 12px;
    border-radius: 4px;
    z-index: 10; 
    font-size: 14px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; 

    background-color: var(--light-1);
    box-shadow: 0px 5px 8px #4A4A4A33;
    & svg, & path {
        fill: var(--dark-4);
    }
    @media (max-width: 400px) {
        width: 100%;
    }
`
export const Picker = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    width: 150px;
    justify-content: space-around;
    height: 150px;
    overflow: hidden;
    margin-bottom: 8px;
    
`
export const Items = styled.div`
    overflow-y: auto;
    height: 100%;
    scrollbar-width: none;
    
`
export const Item = styled.div`
    cursor: pointer;
    padding: 8px;
    height: 30px;
    background-color: ${({ active }) =>
        active ? "var(--purple-2)" : "transparent"};
    color: ${({ active }) =>
        active ? "var(--light-1)" : "var(--light-gray-5)"};
`